'use client';

import { useParams } from 'next/navigation';
import { CatButton } from '../../blocks-components';
import { useTranslations } from 'next-intl';
import { getPDPUrl } from 'components/product-comparison-grid/product-comparison-card/utils';
import Link from 'next/link';
import { MouseEvent } from 'react';

type viewReplacementCTAProps = {
  gaprimaryCTA: string;
  gaBtnEventName: string;
  gaEventContext: string;
};

interface ViewReplacementProps {
  partNumber: string;
  isHeadlessPDPEnabled?: boolean;
  productURL?: string;
  size?: 'lg' | 'xs' | 'sm' | 'md';
  gaEventDetails?: viewReplacementCTAProps;
  classname?: string;
}

export default function ViewReplacement({
  partNumber,
  isHeadlessPDPEnabled,
  productURL = '',
  size = 'sm',
  gaEventDetails,
  classname
}: Readonly<ViewReplacementProps>) {
  const t = useTranslations();
  // TODO - Input Validation - Ensure that all values used from esiteParams are allowed values:
  // lang should always be a two-digit string without numbers or special characters (like 'es');
  // esite should always be a string without numbers or special characters, except for the dash (like demo-dealer).
  const esiteParams = useParams();

  const pdpURL = getPDPUrl({
    esiteParams,
    isHeadlessPDPEnabled,
    productNumber: partNumber,
    productURL
  });
  const viewReplacementCallback = (e: MouseEvent) => {
    if (!isHeadlessPDPEnabled) {
      e.preventDefault();
      window.location.href = pdpURL;
    }
  };

  return (
    <Link
      key={pdpURL}
      href={pdpURL}
      onClick={viewReplacementCallback}
      className="w-100"
    >
      <CatButton
        variant="contrast"
        size={size}
        fullWidth
        data-track-event={gaEventDetails?.gaprimaryCTA}
        data-track-attr-nltext={gaEventDetails?.gaBtnEventName}
        data-track-attr-context={gaEventDetails?.gaEventContext}
        className="h-100"
      >
        <span className={classname}>{t('VIEW_REPLACEMENT')}</span>
      </CatButton>
    </Link>
  );
}
